let scrollDownBtns = document.querySelectorAll('.scroll-down')

if(scrollDownBtns.length) {
    for(let scrollDownBtn of scrollDownBtns) {
        scrollDownBtn.addEventListener('click', () => {
            let section = scrollDownBtn.closest('section')
            let next = section.nextElementSibling
    
            next.scrollIntoView({
                behavior: 'smooth'
            })
        })
    }
}